var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 816,
    height: 767,
    viewBox: "0 0 816 767",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25903_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 816,
    height: 767
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.10352e-05H816V766.667H0V6.10352e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25903_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.413 65.6702C451.757 81.9955 488.885 112.77 513.051 146.389C602.823 271.281 567.341 443.474 431.919 517.41C427.832 519.642 417.968 525.32 414.189 526.382C412.249 526.929 412.369 526.049 412.152 526.022V407.465C470.28 357.646 477.751 267.445 432.099 206.532C425.801 198.129 419.685 192.58 412.152 185.488C388.576 163.294 361.541 149.752 328.117 146.552C323.584 146.117 312.888 144.97 309.992 147.65C297.101 144.412 280.984 148.456 268.373 152.068C206.856 169.681 162.841 226.877 159.852 290.749L159.897 536.106C134.737 534.694 111.985 527.081 93.0412 510.274C71.8692 491.49 60.5692 465.353 58.9452 437.165C56.2879 391.04 56.4505 328.12 58.9532 281.92C68.4545 106.55 252.328 -2.91248 413.413 65.6702Z",
    fill: "#2FBCEE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_25903_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 816,
    height: 767
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.10352e-05H816V766.667H0V6.10352e-05Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_25903_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.412 65.6702C518.263 19.9409 641.763 51.8129 711.564 141.476C746.107 185.848 763.02 237.01 765.349 293.272C767.187 337.653 768.113 395.706 765.357 439.688C762.381 487.193 727.129 527.217 679.82 534.506C674.749 535.288 669.455 534.654 664.405 536.106L664.451 292.01C662.893 274.706 660.167 258.182 654.013 241.908C632.672 185.472 574.029 144.12 513.049 146.389C488.884 112.77 451.756 81.9956 413.412 65.6702Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_25903_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 816,
    height: 767
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.10352e-05H816V766.667H0V6.10352e-05Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_25903_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.151 185.488C346.028 241.354 346.322 351.412 412.151 407.465V526.021C401.759 524.704 376.995 508.469 367.611 501.824C263.319 427.981 230.378 285.49 293.379 173.29C296.384 167.936 306.259 151.104 309.991 147.65C312.887 144.97 323.583 146.117 328.116 146.55C361.54 149.752 388.575 163.294 412.151 185.488Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_25903_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 816,
    height: 767
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.10352e-05H816V766.667H0V6.10352e-05Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_25903_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.654 677.066V617.31C165.654 610.973 163.994 606.32 160.674 603.352C157.354 600.385 152.775 598.901 146.942 598.901C142.114 598.901 137.938 600.31 134.418 603.126C130.895 605.942 129.136 610.168 129.136 615.801V677.066H114.951V615.801C114.951 612.784 114.499 610.194 113.594 608.03C112.687 605.868 111.43 604.106 109.82 602.749C108.21 601.39 106.35 600.385 104.238 599.73C102.126 599.077 99.8097 598.75 97.2963 598.75C93.4723 598.75 89.827 599.681 86.3563 601.541C82.8857 603.404 80.2443 605.842 78.4337 608.86V677.066H64.0977V587.432L74.359 586.677L76.9243 596.334H77.3777C80.0937 593.016 83.5123 590.428 87.639 588.564C91.763 586.704 96.0897 585.772 100.616 585.772C112.587 585.772 120.686 590.352 124.911 599.504H125.212C127.827 594.777 131.323 591.28 135.7 589.017C140.076 586.753 145.03 585.621 150.564 585.621C154.888 585.621 158.863 586.277 162.484 587.584C166.106 588.892 169.2 590.853 171.764 593.469C174.33 596.086 176.316 599.353 177.726 603.276C179.132 607.201 179.838 611.828 179.838 617.158V677.066H165.654Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_25903_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 816,
    height: 767
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.10352e-05H816V766.667H0V6.10352e-05Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_25903_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.049 624.251C290.948 619.525 290.344 615.501 289.239 612.179C288.131 608.859 286.621 606.143 284.712 604.031C282.8 601.918 280.487 600.386 277.771 599.429C275.053 598.474 272.085 597.995 268.867 597.995C261.221 597.995 255.612 600.134 252.043 604.409C248.469 608.685 246.433 615.299 245.931 624.251H291.049ZM273.395 678.878C258.605 678.878 247.941 674.879 241.404 666.881C234.863 658.883 231.595 646.486 231.595 629.683C231.595 615.501 234.663 604.611 240.8 597.014C246.935 589.419 256.241 585.621 268.716 585.621C274.048 585.621 278.903 586.429 283.277 588.035C287.655 589.646 291.375 592.162 294.444 595.581C297.512 599.002 299.901 603.302 301.612 608.483C303.323 613.666 304.177 619.875 304.177 627.118C304.177 628.226 304.152 629.407 304.103 630.666C304.051 631.925 303.975 633.057 303.876 634.059H246.232C246.433 639.998 247.137 645.001 248.345 649.074C249.552 653.149 251.337 656.419 253.701 658.883C256.064 661.349 259.007 663.134 262.529 664.239C266.049 665.347 270.225 665.899 275.053 665.899C279.581 665.899 283.829 665.423 287.805 664.466C291.777 663.511 295.676 662.078 299.5 660.166L301.16 672.237C297.335 674.251 293.109 675.859 288.484 677.066C283.856 678.274 278.827 678.878 273.395 678.878Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_25903_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 816,
    height: 767
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.10352e-05H816V766.667H0V6.10352e-05Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_25903_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.823 677.066V617.612C412.823 610.973 411.088 606.169 407.618 603.201C404.147 600.236 399.092 598.75 392.452 598.75C390.54 598.75 388.578 598.977 386.567 599.428C384.554 599.881 382.592 600.537 380.683 601.39C378.77 602.246 377.008 603.302 375.4 604.56C373.791 605.817 372.482 607.252 371.478 608.86V677.066H357.142V587.432L367.403 586.677L369.818 596.185H370.27C373.387 592.765 377.235 590.125 381.814 588.261C386.391 586.402 391.244 585.47 396.376 585.47C405.932 585.47 413.427 588.137 418.859 593.469C424.292 598.802 427.008 606.849 427.008 617.612V677.066H412.823Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_25903_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 816,
    height: 767
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.10352e-05H816V766.667H0V6.10352e-05Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_25903_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.212 598.297V653.526C503.212 658.256 504.367 661.625 506.683 663.637C508.996 665.65 512.215 666.656 516.34 666.656C517.647 666.656 519.005 666.554 520.413 666.353C521.823 666.153 522.98 665.85 523.885 665.446L524.791 676.313C523.38 677.017 521.547 677.569 519.283 677.972C517.019 678.373 514.681 678.576 512.265 678.576C504.517 678.576 498.684 676.489 494.761 672.313C490.839 668.14 488.876 662.029 488.876 653.98V598.297H476.351V587.13H489.329L492.045 564.797L503.212 563.59V587.13H525.395V598.297H503.212Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_25903_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 816,
    height: 767
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.10352e-05H816V766.667H0V6.10352e-05Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_25903_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M644.754 647.49C644.754 657.551 641.887 665.272 636.154 670.654C630.419 676.036 621.615 678.727 609.746 678.727C597.874 678.727 589.097 676.011 583.414 670.578C577.729 665.146 574.889 657.45 574.889 647.49V587.13H589.073V647.188C589.073 659.463 596.014 665.598 609.897 665.598C623.678 665.598 630.57 659.463 630.57 647.188V587.13H644.754V647.49Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_25903_1444",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 816,
    height: 767
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.10352e-05H816V766.667H0V6.10352e-05Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_25903_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M756.872 650.659C756.872 659.109 754.356 665.925 749.327 671.105C744.295 676.288 736.248 678.877 725.183 678.877C719.751 678.877 714.671 678.247 709.943 676.991C705.212 675.735 701.088 673.848 697.568 671.332L699.38 658.959C702.798 661.576 706.848 663.537 711.527 664.844C716.204 666.152 720.706 666.804 725.032 666.804C731.672 666.804 736.426 665.397 739.292 662.579C742.16 659.764 743.594 656.241 743.594 652.017C743.594 648.597 742.46 645.907 740.198 643.944C737.935 641.981 735.091 640.323 731.672 638.964C728.251 637.607 724.554 636.324 720.58 635.116C716.606 633.908 712.908 632.351 709.49 630.439C706.068 628.528 703.228 626.039 700.963 622.968C698.7 619.901 697.568 615.853 697.568 610.821C697.568 603.177 700.21 597.067 705.491 592.487C710.772 587.909 718.594 585.621 728.956 585.621C737.708 585.621 745.804 587.333 753.251 590.751L752.043 602.824C748.219 601.216 744.272 600.009 740.198 599.201C736.123 598.399 732.276 597.995 728.654 597.995C723.222 597.995 718.946 599.076 715.828 601.24C712.708 603.404 711.15 606.347 711.15 610.068C711.15 613.288 712.282 615.777 714.546 617.536C716.808 619.297 719.623 620.833 722.995 622.139C726.364 623.448 730.035 624.681 734.011 625.836C737.984 626.993 741.655 628.528 745.027 630.439C748.396 632.351 751.214 634.891 753.476 638.059C755.74 641.228 756.872 645.429 756.872 650.659Z",
    fill: "#231F20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e50b6e06067ab554f8cd7ff2b1cbdbed.svg";
export { ForwardRef as ReactComponent };